/**
 * 目前剩下跟色色話題使用 legacy-explore
 * 其他頁面統一使用 explore
 * TODO: 移除非匿名聊邏輯或重構匿名聊
 */
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Immutable from 'immutable'
import {
  setType,
  setClas,
  setMode,
  postsArticleLoaded,
  getIndexPostList,
  getIndexCarousel,
  postLike,
  resetLists,
  resetPosts,
  getInitialPostList,
} from '@app-core/posts/actions'
import { initialState } from '@app-core/posts/reducer'
import { bindActionCreators } from 'redux'
import {
  compose,
  connect,
  withBeacon,
  withRouter,
  withContext,
  withTranslation,
  setStatic,
  withReloadPageAfterLogin,
} from '@hocs'
import DFP from '@components/DFP'
import ArticleCard from '@components/ArticleCard'
import LayoutContent from '@components/LayoutContent'
import MasonryVirtualized from '@components/MasonryVirtualized'
import IndexHead from './components/IndexHead'
import PcCarousel from './components/PcCarousel'
import MobileCarousel from './components/MobileCarousel'
import PaginationLink from '@components/PaginationLink'
import cx from 'classnames'
import { checkIsIndex } from '@libs/webHelper'
import nav from '@routes/nav'
import { NotFoundError } from '@features/errors/NotFoundError'
import { trackWebCategoryViewEvent } from '@libs/eventTracking/category'
import CreatePostButtonBlock from './components/CreatePostButtonBlock'
import ShowADScript from '@components/ShowADScript'
import { withRNApp } from '@libs/RNApp'
import ExploreTitleBar from '@features/explore/ExploreTitleBar'
import R18Alert from '@components/R18Alert/index'
import SexBanner from './components/SexBanner'
import sexConfigJSON from '../../../public/config/sex.json'
import { trackWebCategoryBannerEnterAd } from '@libs/eventTracking/category'
import { getUrlSearchParams } from '@libs/url-utils'

const INDEX_STICKY_AD_RULES = [
  { adElementId: 'div-gpt-ad-1576720024869-0', sticky: 0 },
  { adElementId: 'div-gpt-ad-1576720045152-0', sticky: 1 },
]

const INDEX_AD_RULES = [
  { adUnitPath: 'All_native_1', adSize: ['fluid', [1, 1]] },
  { adUnitPath: 'All_native_2', adSize: ['fluid', [1, 1]] },
  { adUnitPath: 'All_native_3', adSize: ['fluid', [1, 1]] },
  { adUnitPath: 'All_native_4', adSize: ['fluid', [1, 1]], default: true }, // default AD
]

const MAX_PAGINATION_INDEX = 10

class ExploreContainer extends PureComponent {
  constructor(props) {
    super(props)
    this.hasSentTrackEvent = false
  }

  componentDidMount() {
    this._handleSendTrackCategoryViewEvent()
  }

  _handleSendTrackCategoryViewEvent = () => {
    if (this.hasSentTrackEvent) return
    this.hasSentTrackEvent = true

    if (typeof window !== 'undefined') {
      const fromPage = getUrlSearchParams(window.location)?.fromPage ?? {}
      const category = this.props.posts.getIn(['posts', 'clas'])

      trackWebCategoryViewEvent({
        category,
        fromPage,
      })
    }
  }

  static defaultProps = {
    isApp: false,
    isIndex: false,
    router: {},
    currentUser: null,
    posts: initialState,
    PcCarousel: null,
    MobileCarousel: null,
    setMode: () => false,
    resetLists: () => false,
    getIndexPostList: () => false,
    getIndexCarousel: () => false,
    postsArticleLoaded: () => false,
    t: () => '',
  }

  _handleInfiniteScroll = () => {
    const { posts, getIndexPostList } = this.props
    const hasMore = posts.getIn(['posts', 'hasMore'], true)
    const isLoading = posts.getIn(['posts', 'isLoading'], false)

    if (hasMore && !isLoading && getIndexPostList) {
      const type = posts.getIn(['posts', 'type'])
      const clas = posts.getIn(['posts', 'clas'])
      const mode = posts.getIn(['posts', 'mode'])
      const page = posts.getIn(['posts', 'page'])
      const score = posts.getIn(['posts', 'score'])
      const touch = posts.getIn(['posts', 'currentList']).toJS()
      getIndexPostList({ type, clas, mode, page, score, touch })
    }
  }

  componentWillUnmount() {
    // if router change then auto scroll to top(reset scroll position).
    if (typeof window !== 'undefined') window.scrollTo(0, 0)
  }

  _postsArticleLoaded = (index) => () => this.props.postsArticleLoaded({ index })

  _fetchDFPADRules = (index = -1) => {
    // Sticky AD
    const findIndex = INDEX_STICKY_AD_RULES.findIndex((ad) => ad.sticky === index)
    if (findIndex !== -1) return { ...INDEX_STICKY_AD_RULES[findIndex] }
    // Each offset(7) render 1 AD.
    const defaultADIndex = INDEX_AD_RULES.findIndex((ad) => ad.default || !ad.used)
    if (index >= 7) {
      let notUsedADIndex = INDEX_AD_RULES.findIndex((ad) => ad.used === index || !ad.used)
      if (notUsedADIndex === -1) {
        notUsedADIndex = defaultADIndex
      } else {
        INDEX_AD_RULES[notUsedADIndex].used = index
      }
      return { ...INDEX_AD_RULES[notUsedADIndex] }
    }
    return { ...INDEX_AD_RULES[defaultADIndex] }
  }

  _handleRenderCell = (index) => {
    const { posts, articles, isApp } = this.props
    const isSex = posts.getIn(['posts', 'clas']) === 'sex'
    const hasMore = posts.getIn(['posts', 'hasMore'], true)
    const article = articles.get(index).toJS()
    const isAD = article.type === 'ad'
    const isHidden = article.type === 'hidden'

    if (isAD) article.postID = `div-gpt-ad-${index.toString().padStart(8, '0')}-${index}`
    if (isApp && isAD) return null // App should not display ADs.

    const { adElementId, adSize, adUnitPath } = this._fetchDFPADRules(isAD ? index : -1)

    const classNames = cx('masonry-article', { isAD, isHidden }) // zi_ad_inlisted: isAD, zi_ad_li_iL: isAD

    const zoomIn =
      articles.size > 7 && index !== 0
        ? hasMore && !article.loaded && index > articles.size - 7
        : false

    if (isHidden) return <div />

    // window.popdailyAdsTarget com from GTM's Global Target.
    const adTargeting = typeof window !== 'undefined' ? window.popdailyAdsTarget : {}

    return isAD ? (
      <DFP
        adElementId={adElementId}
        adSize={adSize}
        adUnitPath={adUnitPath}
        adTargeting={adTargeting}
        className={classNames}
      />
    ) : (
      <ArticleCard
        isSex={isSex}
        className={classNames}
        article={article}
        isLoaded={!!article.loaded}
        onLoaded={this._postsArticleLoaded(index)}
        zoomIn={zoomIn}
      />
    )
  }

  _handleOnClickFilter = async (mode = 'hot') => {
    const { router = {}, amplitudeEventTrack } = this.props
    const {
      asPath: page,
      query: { website = '' },
    } = router
    const type = website ? 'article' : 'explore'
    amplitudeEventTrack('sort', { type, page, 'sort.by': mode })
    await this.props.setMode({ mode })
    await this.props.resetLists()
    await this._handleInfiniteScroll()
  }

  _handleOnClickSexBanner = (e) => {
    const { posts } = this.props
    e.preventDefault()
    const url = sexConfigJSON['banner']['url']
    // 目前只有 sex banner，url 先寫死
    trackWebCategoryBannerEnterAd({
      category: posts.getIn(['posts', 'clas']),
      toPageUrl: url,
    })

    window.location.href = url
  }

  render() {
    const { isIndex, posts, PcCarousel, MobileCarousel, articles, isApp, hasError } = this.props
    if (hasError) {
      return <NotFoundError isApp={isApp} />
    }

    const isSex = posts.getIn(['posts', 'clas']) === 'sex'
    const carouselNew = posts.getIn(['posts', 'carousel', 'carouselNew'], Immutable.fromJS([]))
    const carouselPost = posts.getIn(['posts', 'carousel', 'carouselPost'], Immutable.fromJS([]))
    const carouselSlider = posts.getIn(
      ['posts', 'carousel', 'carouselSlider'],
      Immutable.fromJS([]),
    )
    const hasMore = posts.getIn(['posts', 'hasMore'], true)
    const category = posts.getIn(['posts', 'clas'])

    const {
      query: { website = '', postID = '', page },
    } = this.props.router
    const nextPaginationIndex = page ? Number(page) + 1 : 2
    const columns = website && !postID ? [0, 750, 1140] : [null, 0, 720]
    const fixedList = []
    articles.forEach((article, index) => {
      article.get('type', '') === 'ad' && fixedList.push(index)
    })

    return (
      <LayoutContent isApp={isApp} noTopAd={isSex} hasNavigation>
        {isSex && <SexBanner handleBannerOnClick={this._handleOnClickSexBanner} />}
        {isSex && <R18Alert />}
        <ShowADScript />
        <IndexHead />
        <ExploreTitleBar category={category} />
        {isIndex && carouselPost.size && carouselSlider.size ? PcCarousel : null}
        {isIndex && carouselNew.size ? MobileCarousel : null}
        <CreatePostButtonBlock type={category} />
        <MasonryVirtualized
          fixed={fixedList}
          hasMore={hasMore}
          cells={articles}
          columns={columns}
          handleRenderCell={this._handleRenderCell}
          handleInfiniteScroll={this._handleInfiniteScroll}
        />
        {hasMore && nextPaginationIndex <= MAX_PAGINATION_INDEX && (
          <PaginationLink url={`?page=${nextPaginationIndex}`} />
        )}
      </LayoutContent>
    )
  }
}

const mapStateToProps = (state) => state
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      postLike,
      getIndexPostList,
      getIndexCarousel,
      resetLists,
      resetPosts,
      setClas,
      setMode,
      postsArticleLoaded,
    },
    dispatch,
  )
const mergeProps = (state, dispatchProps, ownProps) => {
  const { posts } = state
  const {
    postLike,
    getIndexCarousel,
    getIndexPostList,
    resetLists,
    resetPosts,
    setClas,
    setMode,
    postsArticleLoaded,
  } = dispatchProps

  const articles = posts.getIn(['posts', 'list'])

  const carouselNew = posts.getIn(['posts', 'carousel', 'carouselNew'], Immutable.fromJS([]))
  const carouselPost = posts.getIn(['posts', 'carousel', 'carouselPost'], Immutable.fromJS([]))
  const carouselSlider = posts.getIn(['posts', 'carousel', 'carouselSlider'], Immutable.fromJS([]))
  const carouselIsLoading = posts.getIn(['posts', 'carousel', 'isLoading'], false)

  const isIndex = checkIsIndex(state, ownProps.router)

  return {
    ...state,
    ...ownProps,
    isIndex,
    articles,
    getIndexCarousel,
    getIndexPostList,
    resetLists,
    resetPosts,
    setClas,
    setMode,
    postsArticleLoaded,
    postLike: ({ postID, isLike, data = {} }) => postLike({ postID, isLike, data }),
    PcCarousel: (
      <PcCarousel
        isLoading={carouselIsLoading}
        carouselSlider={carouselSlider}
        carouselPost={carouselPost}
      />
    ),
    MobileCarousel: <MobileCarousel isLoading={carouselIsLoading} carousel={carouselNew} />,
  }
}

export default compose(
  withRNApp,
  withBeacon,
  withRouter,
  withTranslation(),
  withReloadPageAfterLogin,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  setStatic(
    'getInitialProps',
    async ({ res, isServer = true, store, query, asPath = '', namespacesRequired }) => {
      // 強制設定 query 為匿名聊或色色話題
      query = { clas: asPath.includes('secret') ? 'secret' : 'sex' }

      const state = store.getState()
      const paginationIndex = (query && Number(query.page)) || 1
      // CSR: change will auto reset data.
      if (!isServer) await store.dispatch(resetPosts())

      let hasError = false
      const allCategories = [...nav.categories, ...nav.events]

      // SET Type
      const { website = '', postID = '', preview = '', p = '', s = '' } = query

      // 檢查 [website] 是否有效
      if (website && website != 'trend' && allCategories.includes(website) === false) {
        hasError = true
        res.status(404)

        return { hasError, namespacesRequired }
      }

      // [redirect] s: search/post/
      if (s) res.redirect(searchUrl(s))

      // [redirect] preview: wordpress preview `/demo2/${req.query.p}`
      if (p && preview) res.redirect(`/demo2/${p}&t=${new Date().getTime()}`)

      // index explore start
      let query_type = 'explore'
      // 不是 /[website]/[postID] 或 /trend
      if (!!website && !postID && website !== 'trend') query_type = 'website'
      const type = state.posts.getIn(['posts', 'type'])
      if (type !== query_type) {
        await store.dispatch(setType({ type: query_type }))
        await store.dispatch(setMode()) // if clas has change, set Default 'hot'.
      }

      // SET Clas
      const { clas: explore_clas = 'featured', website: website_clas = '' } = query

      // 檢查 [clas] 是否有效
      if (explore_clas && allCategories.includes(explore_clas) === false) {
        hasError = true
        res.status(404)
        return {
          hasError,
          namespacesRequired,
        }
      }

      let query_clas = 'featured'
      if (explore_clas) query_clas = explore_clas
      if (website_clas) query_clas = website_clas
      const clas = state.posts.getIn(['posts', 'clas'])
      if (clas !== query_clas) {
        await store.dispatch(setClas({ clas: query_clas }))
        await store.dispatch(setMode()) // if clas has change, set Default 'hot'.
      }

      // GET Mode
      const mode = (await store.getState().posts.getIn(['posts', 'mode'])) || 'new'

      // only [explore && featured](index) need render Carousels.

      if (
        asPath === '/' ||
        asPath === '/explore/featured' ||
        (query_type === 'explore' && query_clas === 'featured')
      ) {
        await store.dispatch(getIndexCarousel({}))
      }

      await store.dispatch(
        getInitialPostList({
          type: query_type,
          clas: query_clas,
          mode,
          paginationIndex:
            paginationIndex <= MAX_PAGINATION_INDEX ? paginationIndex : MAX_PAGINATION_INDEX,
        }),
      )

      return {
        hasError,
        namespacesRequired,
      }
    },
  ),
  withContext(
    {
      isApp: PropTypes.bool.isRequired,
      isIndex: PropTypes.bool,
      setMode: PropTypes.func,
      postLike: PropTypes.func.isRequired,
    },
    ({ isApp, isIndex, setMode, postLike }) => ({ isApp, isIndex, setMode, postLike }),
  ),
)(ExploreContainer)
